export class ApiKeyValidator {
    readonly _apiKey: string;
    // Regular expression patterns
    private static readonly _apiKeyV1Pattern = /^ckey_([a-f0-9]{27})$/;
    private static readonly _apiKeyV2Pattern = /^cqt_(wF|rQ)([bcdfghjkmpqrtvwxyBCDFGHJKMPQRTVWXY346789]{26})$/;

    static readonly INVALID_API_KEY_MESSAGE = "Invalid or missing API key (sign up at covalenthq.com/platform)";

    constructor(apiKey: string) {
        this._apiKey = apiKey;
    }

    isValidApiKey(): boolean {
        return ApiKeyValidator._apiKeyV1Pattern.test(this._apiKey) || ApiKeyValidator._apiKeyV2Pattern.test(this._apiKey);
    }
}